import { render, staticRenderFns } from "./WorkSelector.vue?vue&type=template&id=2d933a53&scoped=true"
import script from "./WorkSelector.vue?vue&type=script&lang=js"
export * from "./WorkSelector.vue?vue&type=script&lang=js"
import style0 from "./WorkSelector.vue?vue&type=style&index=0&id=2d933a53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d933a53",
  null
  
)

export default component.exports